exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.field-selection-container {\n    width: 100%;\n    margin: 10px 0;\n}\ninput {\n    min-height: 30px;\n}\n.error {\n    width: 100%;\n    color: red;\n}\n", ""]);

// exports
